export default __webpack_public_path__ + "static/media/OP.2496e481.svg";